<template>
    <div>

        <div v-if="isEditor && isVisible" :style="style" style="width: 350px;"
             id="colorPickerElement" @mousedown="stopMousedownPropagation">
            <h5>Update Drop Party</h5>
            <p style="margin-bottom: 15px">Order No.: {{order.orderNumber}}</p>

            <Form :model="dropPartyForm" :rules="ruleValidatedrop" label-position="top" ref="dropPartyForm">
                <Row :gutter="10">
                    <Col span="24" >
                        <FormItem prop="dropPartyName">
                            <ApolloQuery :query="query_SEARCH_DROPPINGPARTY" :debounce="500" :skip="skip.dropPartySkip"
                                         :variables="{droppingPartyFilter:dropPartyFilter, filterDroppingCity:[]}">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="Drop Party" @on-search="onSearchDropParty($event)"
                                                      v-model="dropPartyForm.dropPartyName">
                                            <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                    v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                <div class="ivu-select-item-div" @click="assignDropParty(companyObj)">{{companyObj.name}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                    <Col span="24" style="margin: 0 0 -20px 0">
                        <FormItem  prop="add1">
                            <Input placeholder="Address 1" v-model="dropPartyForm.add1"></Input>
                        </FormItem>
                    </Col>
                    <Col span="24" style="margin: 0 0 -20px 0">
                        <FormItem  prop="add2">
                            <Input placeholder="Address 2" v-model="dropPartyForm.add2"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem prop="area">
                            <Input placeholder="Area" v-model="dropPartyForm.area"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem  prop="pincode">
                            <Input number placeholder="PIN" v-model="dropPartyForm.pincode"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem  prop="city" >
                            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                                         :debounce="500" :skip="skip.citySkip">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="City" v-model="dropPartyForm.city"
                                                      @on-search="onSearchCity">
                                            <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                    <Col span="12" style="margin: 0 0 -20px 0">
                        <FormItem prop="state" >
                            <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                                         :debounce="500" :skip="skip.stateSkip">
                                <template slot-scope="{ result: { loading, error, data } }">
                                    <div v-if="loading"> Loading...</div>
                                    <div v-else-if="error"> Error Occured. {{error}}</div>
                                    <div v-else>
                                        <AutoComplete placeholder="State" v-model="dropPartyForm.state"
                                                      @on-search="onSearchState">
                                            <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                                <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                            </Option>
                                        </AutoComplete>
                                    </div>
                                </template>
                            </ApolloQuery>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div style="float: right">
                <Button @click="checkDropForm" :loading="loader1">
                    <span v-if="!loader1">Update</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button style="margin-left: 10px" @click="close()">Cancel</Button>
            </div>
        </div>

        <!--<div v-if="isRenderer" style="text-align: center" :class="cellProperties.readOnly?'cell-readonly':''">-->
            <!--{{value}}-->
        <!--</div>-->

    </div>
</template>

<script>
    import {BaseEditorComponent} from '@handsontable/vue'
    import {Constants} from "../../Constants/Constant"
    import ValidationRules from '../../Constants/ValidationRules'
    import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders"
    import {SEARCH_DROPPINGPARTY} from '../../graphql/queries/companies'
    import { SEARCH_CITY, SEARCH_STATE } from '../../graphql/queries/territories'
    import {CREATE_UPDATE_ORDER_COMPANY} from "../../graphql/mutations/companies";

    export default {
        name: "DropPartyPopup",
        extends: BaseEditorComponent,
        data:function () {
            return{
                Constants: Constants,
                order: null,
                hotInstance: null,
                TD: null,
                row: null,
                col: null,
                prop: null,
                originalValue: null,
                value: '',
                cellProperties: null,
                isVisible: false,
                isEditor: null,
                isRenderer: null,
                editorElement: null,
                style: {
                    position: "absolute",
                    padding: "15px",
                    background: "#fff",
                    zIndex: 999,
                    border: "1px solid #000",
                    left: "0px",
                    top: "0px"
                },
                loader1: false,
                query_SEARCH_DROPPINGPARTY: SEARCH_DROPPINGPARTY,
                query_SEARCH_CITY: SEARCH_CITY,
                query_SEARCH_STATE: SEARCH_STATE,
                dropPartyForm:{
                    dropPartyName: '',
                    dropPartyId: '',
                    mobile: '',
                    email: '',
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: '',
                    state: '',
                    city: ''
                },
                ruleValidatedrop: {dropPartyName: ValidationRules.textField('Drop Party Name')},
                dropPartyFilter: '%%',
                cityFilter: '%%',
                stateFilter: '%%',
                skip: {pickupPartySkip: true, dropPartySkip: true, citySkip: true, stateSkip: true},
            }
        },
        methods:{
            stopMousedownPropagation: function(e) {
                e.stopPropagation();
            },
            prepare: function(row, col, prop, td, originalValue, cellProperties) {
                BaseEditorComponent.options.methods.prepare.call(this, row, col, prop, td, originalValue, cellProperties);
                const tdPosition = td.getBoundingClientRect();
                this.style.left = tdPosition.left + window.pageXOffset + 'px';
                this.style.top = tdPosition.top + window.pageYOffset + 'px';
            },
            open: function() {
              let screen = this.$parent.$parent.$parent.screen
              let ordersVariable = screen + '_orders'
              let pRow = this.hotInstance.toPhysicalRow(this.row)                             //When accessing original array
              this.order = this.$parent.$parent.$parent[ordersVariable][pRow]

                if(!this.order.orderDetails.dropPoint.dropPartyId){
                    this.onEditDropOfOrder(this.order)
                }else{
                    this.onEditDropOfOrderDetail(this.order.orderDetails)
                }

                this.isVisible = true
            },
            focus: function() {
                this.isVisible = true;
            },
            close: function() {
                this.isVisible = false;
            },
            setValue: function(value) {
                this.value = value;
            },
            getValue: function() {
                return this.value;
            },
            onSearchDropParty: function(val){
                this.dropPartyFilter = '%' + val + '%';
                this.skip.dropPartySkip = false;
            },
            assignDropParty(companyObj){
                this.dropPartyForm.dropPartyId = companyObj.id;
                this.dropPartyForm.mobile = companyObj.mobile;
                this.dropPartyForm.email = companyObj.email;
            },
            onSearchCity: function(val){
                this.cityFilter = '%' + val + '%';
                this.skip.citySkip = false;
            },
            onSearchState: function(val){
                this.stateFilter = '%' + val + '%';
                this.skip.stateSkip = false;
            },
            onEditDropOfOrder(order){
                this.dropPartyForm.dropPartyName = order.droppingpartyobject.name;
                this.dropPartyForm.dropPartyId = order.droppingpartyobject.id;
                this.dropPartyForm.mobile = order.droppingpartyobject.mobile;
                this.dropPartyForm.email = order.droppingpartyobject.email;
                this.dropPartyForm.add1 = order.droppingpartyobject.address[0].add1;
                this.dropPartyForm.add2 = order.droppingpartyobject.address[0].add2;
                this.dropPartyForm.area = order.droppingpartyobject.address[0].area;
                this.dropPartyForm.pincode = order.droppingpartyobject.address[0].pincode;
                this.dropPartyForm.state = order.droppingpartyobject.address[0].state;
                this.dropPartyForm.city = order.droppingpartyobject.address[0].city;
            },
            onEditDropOfOrderDetail(orderDetails){
                this.dropPartyForm.dropPartyName = orderDetails.dropPoint.dropPartyName;
                this.dropPartyForm.dropPartyId = orderDetails.dropPoint.dropPartyId;
                this.dropPartyForm.mobile = orderDetails.dropPoint.mobile
                this.dropPartyForm.email = orderDetails.dropPoint.email
                this.dropPartyForm.add1 = orderDetails.dropPoint.add1;
                this.dropPartyForm.add2 = orderDetails.dropPoint.add2;
                this.dropPartyForm.area = orderDetails.dropPoint.area;
                this.dropPartyForm.pincode = orderDetails.dropPoint.pincode;
                this.dropPartyForm.state = orderDetails.dropPoint.state;
                this.dropPartyForm.city = orderDetails.dropPoint.city;
            },
            checkDropForm(){
                this.$refs['dropPartyForm'].validate((valid) => {
                    if (valid) {
                        let mappedAreas = this.$store.state.mappedAreas
                        let obj = {dropPoint: this.dropPartyForm, dropAreaGroup: mappedAreas[this.dropPartyForm.area.toLowerCase()] || null}
                        this.updateRecord(this.order.orderDetails.id, obj, 'orderDetails', 'loader1')
                        this.saveOrderCompany()
                    }
                })
            },
            async saveOrderCompany(){
                let response = await this.$apollo.mutate({
                  mutation: CREATE_UPDATE_ORDER_COMPANY,
                  variables: {
                    orderCompany: {
                      name: this.dropPartyForm.dropPartyName,
                      mobile: this.dropPartyForm.mobile,
                      email: this.dropPartyForm.email,
                      addressLine1: this.dropPartyForm.add1,
                      addressLine2: this.dropPartyForm.add2,
                      area: this.dropPartyForm.area,
                      city: this.dropPartyForm.city,
                      state: this.dropPartyForm.state,
                      pincode: this.dropPartyForm.pincode,
                      originalCompanyId: this.dropPartyForm.dropPartyId,
                      type: 'DROP',
                      orderId: this.order.id
                    },
                    updateColumns: ['name', 'mobile', 'email', 'addressLine1', 'addressLine2', 'area', 'city', 'state', 'pincode', 'originalCompanyId']
                  }
                })
                if(response.data) this.$Message.success('Order Company saved successfully!')
            },
            async updateRecord(id, obj, table, loaderStr){
                this[loaderStr] = true
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: { id: id, obj: obj}
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!')
                    this[loaderStr] = false
                    this.close()
                    this.finishEditing()
                }
            },
        },
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
</style>
